
import dayjs from "dayjs"
import NP from "number-precision"
import sHeader from "@/components/sheader.vue"
import payment from "@/components/checkout/payment"
// import payThreeds from "@/components/checkout/pay-threeds"
import { cardList, pay, payList, authorizePay } from "@/api/pay.js"
import { showGlobalMessage } from "@/utils/utils"

function getCardListFromPayList(data) {
  const payTypeInfo = data.payTypeInfos.find(v => v.payWay == 900)
  const payItemInfoList = payTypeInfo && payTypeInfo.payItemInfoList
  return payItemInfoList.filter(v => v.signNum)
}

function _getParamsStr(payUrl) {
  let str = ""
  if (payUrl && payUrl.includes("?")) {
    str = payUrl.split("?")[1]
  }
  return str
}

export default {
  components: {
    sHeader,
    payment
    // payThreeds
  },
  layout: "onlyFooter",
  props: {},
  data() {
    return {
      loading: false,
      countDown: 0,
      price: "",
      payItemInfoList: [],
      signNum: "",
      timer: null
    }
  },
  computed: {
    countDownShowText() {
      return dayjs(this.countDown).format("mm:ss")
    },
    showPromitonSlogan() {
      const item = this.payItemInfoList.find(v => v.signNum == this.signNum)
      return item ? item.payPromitonSloganList : false
    },
    paymentDiscountAmount() {
      const item = this.payItemInfoList.find(v => v.signNum == this.signNum)
      return item ? item.paymentDiscountAmount : ""
    },
    canPay() {
      return this.payItemInfoList && this.payItemInfoList.length && this.signNum
    }
  },
  watch: {},
  mounted() {
    document.title = this.$t("pageTitle.cashier")
    const query = this.$route.query
    if (query && Object.keys(query).length) {
      this.orderNo = query.orderNo
      this.orderList = query.orderList
      this.getPayList()
      if (query.message) {
        this.$message.error(query.message)
      }
    } else {
      this.$navigation.push({
        path: "/cart"
      })
    }
  },
  methods: {
    fen2Yuan(num) {
      if (isNaN(num)) return ""
      num = Number(num)
      return (num / 100).toFixed(2)
    },
    getNumber(nums) {
      const num = this.fen2Yuan(nums)
      const str = num.toString()
      const res = str.split(".")
      return res[0]
    },
    getSmallNumber(nums) {
      const num = this.fen2Yuan(nums)
      const str = num.toString()
      const res = str.split(".")
      return res.length === 2 ? res[1] : ""
    },
    goHome() {
      this.$navigation.replace({
        path: "/"
      })
    },
    handlePayChanged(val) {
      this.signNum = val
      this.getPayList()
    },
    handleCardChanged(val) {
      this.signNum = val.payload
      try {
        this.price = NP.times(
          Number(this.payItemInfoList.find(v => v.signNum == this.signNum).afterPaymentProPrice),
          100
        )
      } catch (error) {
        console.log(error)
      }
    },
    setCountDownTimer() {
      if (this.timer) {
        clearInterval(this.timer)
      }
      if (this.countDown > 0) {
        this.timer = setInterval(() => {
          this.countDown = this.countDown - 1000

          if (this.countDown <= 0) {
            clearInterval(this.timer)
            this.$navigation.push({
              path: "/order_details",
              query: {
                orderId: this.orderNo
              }
            })
          }
        }, 1000)
      }
    },
    async getPayList() {
      this.loading = true
      try {
        const { data: res } = await payList({
          orderNo: this.orderNo,
          salesType: 1, // 销售类型
          ip: "127.0.0.1"
        })
        this.payItemInfoList = getCardListFromPayList(res)
        if (this.signNum) {
          // 新绑卡会走到这里，直接使用新卡的促销优化金额
          this.price = NP.times(
            Number(this.payItemInfoList.find(v => v.signNum == this.signNum).afterPaymentProPrice),
            100
          )
        } else {
          // 初始化，使用默认金额
          this.price = NP.times(Number(res.payFee), 100)
        }
        this.countDown = res.remainPayTime
        this.setCountDownTimer()
      } catch (error) {
        console.log(error)
        showGlobalMessage({
          message: `${error.msg || error.result || error.sourceMsg || this.$t("pendingPayment.payFail")}[${
            error.code
          }]`,
          gap: 150,
          iconClass: "messageWarning"
        })
        if (error.code === "1008") {
          setTimeout(() => {
            this.$navigation.push({
              path: "/order_details",
              query: {
                orderId: this.orderNo
              }
            })
          }, 1000)
        }
      } finally {
        this.loading = false
      }
    },
    // handlePaySuccess() {
    //   this.$navigation.replace({
    //     path: "/payment_result",
    //     query: {
    //       orderNo: this.orderNo,
    //       orderList: this.orderList
    //     }
    //   })
    // },
    // handlePayFail() {
    //   this.$navigation.replace({
    //     path: "/pending_payment",
    //     query: {
    //       orderNo: this.orderNo,
    //       orderList: this.orderList
    //     }
    //   })
    // },
    async authorizePay(tradeNo) {
      this.loading = true
      try {
        const { data: res } = await authorizePay({
          params: JSON.stringify({
            tradeNo,
            isSaveCardNo: 1
          })
        })
        if (res.paymentStatus == "20001") {
          localStorage.setItem("pay_redirect_url", location.href)
          location.href = location.origin + "/o2opay.html?" + _getParamsStr(res.payUrl)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async handlePay() {
      if (!this.canPay) return
      this.loading = true
      try {
        const { data: payRes } = await pay({
          requestFromUrl: "pending_payment",
          returnUrl: "",
          orderNo: this.orderNo,
          signNum: this.signNum,
          showPayFee: this.price,
          payFeeInCashier: this.price
        })
        if (payRes.tradeNo) {
          this.authorizePay(payRes.tradeNo)
        } else {
          // 支付失败
          showGlobalMessage({
            message: `${payRes.message || this.$t("pendingPayment.payFail")}[0000]`,
            gap: 150,
            iconClass: "messageWarning"
          })
        }
      } catch (error) {
        showGlobalMessage({
          message: `${error.msg || error.result || error.sourceMsg || this.$t("pendingPayment.payFail")}[${
            error.code
          }]`,
          gap: 150,
          iconClass: "messageWarning"
        })
        if (error.code === "1008") {
          setTimeout(() => {
            this.$navigation.push({
              path: "/order_details",
              query: {
                orderId: this.orderNo
              }
            })
          }, 1000)
        }
      } finally {
        this.loading = false
      }
    }
  }
}
